import { FC, useMemo } from 'react';
import classNames from 'classnames';

import CollapsibleList from '../CollapsibleList';

import styles from './SelfIntroduction.module.scss';

const NEW_LINE_REGEX = /\n{3,}/g;
const SPACE_REGEX = / {3,}/g;

const formatContent = (value: string) =>
  value.replace(NEW_LINE_REGEX, '\n\n').replace(SPACE_REGEX, '  ');

const TRANSLATIONS = {
  en: {
    otherIntro: 'Other',
  },
  ja: {
    otherIntro: 'その他特長などの紹介',
  },
};

interface QuestionAndAnswer {
  answer: string;
  question: string;
}

interface Props {
  background?: boolean;
  content?: string;
  filteredQuestionAnswers: Array<QuestionAndAnswer>;
  isDashboardView?: boolean;
  language: 'en' | 'ja';
  title?: string;
}

export const SelfIntroduction: FC<Props> = ({
  background = false,
  content = '',
  filteredQuestionAnswers,
  isDashboardView = false,
  language,
  title = '',
}) => {
  const questionAndAnswersListItems = useMemo(
    () =>
      filteredQuestionAnswers.map(({ answer, question }) => ({
        content: answer,
        title: question,
      })),
    [filteredQuestionAnswers]
  );

  return (
    <div
      className={classNames(styles['z-self-introduction'], {
        [styles['z-self-introduction-background']]: background,
      })}
    >
      <h3
        className={classNames(styles['z-self-introduction-title'], {
          [styles['small-title']]: isDashboardView,
        })}
      >
        {title}
      </h3>
      {filteredQuestionAnswers.length > 0 && (
        <div className={styles['question-answers-section']}>
          <CollapsibleList
            listItems={questionAndAnswersListItems}
            listItemsHeaderVariant="h5"
            isExpanded={true}
          />
        </div>
      )}
      {Boolean(content) && filteredQuestionAnswers.length > 0 && (
        <h4 className={styles['section-title']}>{TRANSLATIONS[language].otherIntro}</h4>
      )}
      <p className={styles['z-self-introduction-content']}>{formatContent(content)}</p>
    </div>
  );
};
export default SelfIntroduction;
export type { Props as SelfIntroductionProps };
